export default __webpack_public_path__ + "../staticImages/advent-header-stars.webp";